import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import Form from 'components/Profile/Consent/Form';
import Authorization from 'components/Profile/Hipaa/Authorization';
import AuthorizePersonModal from 'components/Profile/Hipaa/Authorization/Modal';

const Hipaa = () => {
  const { sectionData, refreshProfile }: any = useOutletContext();
  const [modalOpen, setModalOpen] = useState(false);

  const { contacts } = sectionData || {};
  const { family_members, emergency_contacts } = contacts || {};

  return (
    <>
      <Form stepId="hipaa" formType="hipaa">
        <Authorization contacts={contacts} onRefresh={refreshProfile} onAdd={() => setModalOpen(true)} />
      </Form>

      {/* Rendered beside the consent form, not inside it: the modal has its own Formik form. */}
      {modalOpen && (
        <AuthorizePersonModal
          contacts={{ family_members, emergency_contacts }}
          onClose={() => setModalOpen(false)}
          onAuthorized={refreshProfile}
        />
      )}
    </>
  );
};

export default Hipaa;
